<template>
  <v-content style="background-color: #fafafa">
    <DialogLoginFailed ref="dlgLoginFailed"></DialogLoginFailed>
    <DialogGroupSelect ref="dlgGroupSelect" @onSelect="onSelectGroup"></DialogGroupSelect>
    <v-layout justify-start row class="mt-5">
      <v-flex xs4 class="pl-4 partner">
        <div id="partnerLogo">
        </div>
      </v-flex>
    </v-layout>
    <v-container style="margin-top: 60px">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card flat color="transparent">
            <v-card-text class="text-xs-left title font-weight-bold textfh loginTitle">
              Teilnehmer Login <br>
              <span class="font-weight-light body-1 black--text">{{(i18nKeyPrefix + 'loginParticipantTitle') | translate}}</span>
            </v-card-text>
            <v-card-text>
              <v-form>
                <v-text-field autocomplete="username" v-model="form.pin" :label="$t(i18nKeyPrefix+'loginParticipantNameLabel')" type="text" color="examenis"></v-text-field>
                <v-text-field autocomplete="current-password" id="password" v-model="form.tan" :label="$t(i18nKeyPrefix+'loginParticipantPasswordLabel')" type="password" color="examenis"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="buttonLogin">
              <v-btn color="examenis" class="text-none" block outline @click="doLogin()">{{i18nKeyPrefix+'loginSubmit' | translate}}</v-btn>
            </v-card-actions>
            <span class="loginVersion">Version {{version}}</span>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  // import $ from 'jquery'
  import Vue from 'vue'
  import api from './Login.js'
  import DialogLoginFailed from './../dialogs/DialogLoginFailed'
  import DialogGroupSelect from './../dialogs/DialogGroupSelect'
  export default {
    name: 'Login',
    components: {DialogLoginFailed, DialogGroupSelect},
    data () {
      return {
        i18nKeyPrefix: '',
        logo: null,
        version: '',
        form: {
          pin: '',
          tan: ''
        }
      }
    },
    methods: {
      onLoginFailed (data) {
        this.$refs.dlgLoginFailed.open(data)
      },
      onSelectGroup (group) {
        console.log('onSelectGroup', group)
        api.reLogin(group, this.onLoginOk, this.onLoginFailed)
      },
      onLoginOk (data) {
        var cmp = this
        Vue.prototype.$eventHub.$emit('OnLogin', true)
        Vue.prototype.$api.reqIndex = 0
        api.onLoginOk(data)
        if (data.groupList && data.groupList.length > 1) {
          this.$refs.dlgGroupSelect.open(data.groupList)
        } else {
          cmp.$router.push('/online')
        }
      },
      doLogin (a) {
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.setCredentials(null)
        api.doLogin(this.form, this.onLoginOk, this.onLoginFailed)
        return true
      },
      toggleInput (a) {
        if (Vue.prototype.$api.getJQuery()('#' + a).attr('type') === 'password') {
          Vue.prototype.$api.getJQuery()('#' + a + 'Icon').html('visibility')
          Vue.prototype.$api.getJQuery()('#' + a).attr('type', 'text')
        } else {
          Vue.prototype.$api.getJQuery()('#' + a + 'Icon').html('visibility_off')
          Vue.prototype.$api.getJQuery()('#' + a).attr('type', 'password')
        }
      },
      checkFormClasses () {
        Vue.prototype.$api.getJQuery()('html').find('input').each(function (index, field) {
          if (Vue.prototype.$api.getJQuery()(field).val() !== '') {
            Vue.prototype.$api.getJQuery()(field).addClass('has-content')
          } else {
            Vue.prototype.$api.getJQuery()(field).removeClass('has-content')
          }
        })
      },
      loadCSS: function () {
        let cssName = 'default'
        try {
          cssName = this.$route.params.partnerGuid
          if (!cssName || cssName.length === 0) {
            cssName = 'default'
          }
        } catch (ee) {
          cssName = 'default'
        }
        if (cssName === 'default') {
          try {
            cssName = this.$route.query.css
            if (!cssName || cssName.length === 0) {
              cssName = 'default'
            }
          } catch (ee) {
            cssName = 'default'
          }
        }
        if (cssName === 'undefined') {
          cssName = 'default'
        }
        try {
          if (cssName === 'default') {
            const req = new XMLHttpRequest()
            req.open('GET', document.location, false)
            req.send(null)
            console.log('header', req.getAllResponseHeaders())
            cssName = req.getResponseHeader('X-Default-Partner')
          }
        } catch (eee) {
          cssName = 'default'
        }
        Vue.prototype.$api.cssName = cssName
        let file = document.createElement('link')
        file.rel = 'stylesheet'
        file.href = 'static/' + cssName + '.css'
        console.log('loadCSS', cssName, file.href)
        if (cssName !== 'default' && cssName !== 'undefined' && cssName !== null && cssName.length > 0 && cssName !== 'undefined' && cssName !== 'null' && cssName !== ' ' && cssName !== '  ') {
          this.i18nKeyPrefix = cssName + '_'
        }
        document.head.appendChild(file)
      }
    },
    mounted () {
      this.loadCSS()
      var cmp = this
      this.version = Vue.prototype.$config.VERSION
      Vue.prototype.$eventHub.$emit('OnLogin', false)
      Vue.prototype.$api.getJQuery()('input').keypress(function (e) {
        if (e.which === 13) {
          cmp.doLogin()
          return false
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/loginParticipant/Login.vue